<template>
  <div>
    <div class="d-flex flex-column align-center mt-5 mb-3">
      <div class="questions-title justify-center">
        {{ $t('ProductNowNow.QuestionsTitle') }}
      </div>
      <div style="width:80%;" class="mt-3 justify-center">
      <v-row class="justify-center">
        <v-expansion-panels accordion
        v-for="(question, index) in $t('Home.QuestionsHome')" :key="index"
        >
          <v-expansion-panel>
          <v-expansion-panel-header class="font-weight-medium">{{ question.questions }}</v-expansion-panel-header>
          <v-expansion-panel-content>{{ question.answers }}</v-expansion-panel-content>
          </v-expansion-panel>
       </v-expansion-panels>
      </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import * as firebase from "firebase/app";
export default {
  methods: {
    analyticSignUp() {
      firebase.analytics().logEvent("Sig_ReasProdNowNow");
    },
  },
};
</script>

<style>
.questions-title {
  margin-top: 20px;
  width: 95%;
  text-align: center;
  font-family: Open Sans;
  font-style: normal;
  font-size: 18px;
}
@media (max-width: 500px) {
  .phone-model {
    max-width: 90% !important;
  }

}
</style>